import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: 'textarea[appAutoResize]',
  exportAs: 'appAutoResize'
})
export class AutoResizeDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input')
  onInput() {
    this.resize();
  }

  resize() {
    const textarea = this.el.nativeElement;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  reset() {
    this.el.nativeElement.style.height = 'auto';
  }
}
